import FAQItem from '../../helpers/FAQItem/FAQItem';
import { FAQResponse } from '../../helpers/utils/types';
interface FAQsSectionProps {
  faqs: FAQResponse[];
}
const FAQsSectionCreditHealth = ({ faqs }: FAQsSectionProps) => (
  <div className='flex flex-col items-start gap-5 w-full'>
    <div className='flex flex-col items-start gap-7 w-full'>
      <span className='text-medium font-[400] text-[20px] tracking-[0.4px]'>
        FAQs – Credit Builder with Equifax reporting
      </span>
      <div className='h-px bg-[rgba(213,216,226,0.6)] w-full' />
      {faqs.map((faq) => (
        <div key={faq.faqId} className='flex flex-col items-start gap-5 w-full'>
          <FAQItem question={faq.question} answer={faq.answer} />
          <div className='h-px bg-[rgba(213,216,226,0.6)] w-full' />
        </div>
      ))}
    </div>
  </div>
);

export default FAQsSectionCreditHealth;
